import { Button, Form, Popup, Text } from '@approvalmax/ui/src/components';
import { domain } from 'modules/data';
import { memo } from 'react';
import { useForm } from 'react-hook-form';
import {
    AccountingDomainEntitiesBudgetCheckPeriod,
    AccountingDomainEntitiesBudgetZeroAmountHandlingType,
    useUpdateQBooksBudget,
} from 'shared/data/webApp/v2';
import { useCompanyBasedOnUrl } from 'shared/hooks/useCompanyBasedOnUrl';

import CheckPeriodFormPart from '../../../CheckPeriodFormPart/CheckPeriodFormPart';
import ZeroAmountFormPart from '../../../ZeroAmountFormPart/ZeroAmountFormPart';
import { checkPeriodLearnMoreLink, zeroAmountLearnMoreLink } from './BudgetSettingsPopupContent.constants';
import { messages } from './BudgetSettingsPopupContent.messages';
import { BudgetSettingsPopupContentProps, FormState } from './BudgetSettingsPopupContent.types';

export const BudgetSettingsPopupContent = memo<BudgetSettingsPopupContentProps>((props) => {
    const { budget, onClosePopup } = props;

    const company = useCompanyBasedOnUrl();

    const { mutate: updateQBooksBudget, isLoading: isLoadingUpdateQBooksBudget } = useUpdateQBooksBudget({
        onSuccess: onClosePopup,
    });

    const form = useForm<FormState>({
        values: {
            checkPeriod: budget.checkPeriod || AccountingDomainEntitiesBudgetCheckPeriod.Monthly,
            checkPeriodFirstMonth: budget.checkPeriodFirstMonth,
            zeroAmountHandlingType:
                budget.zeroAmountHandlingType || AccountingDomainEntitiesBudgetZeroAmountHandlingType.NotConsider,
        },
    });

    const handleSubmit = form.handleSubmit((data) => {
        updateQBooksBudget({
            params: {
                path: {
                    companyId: company.id,
                    budgetId: budget.budgetId,
                },
            },
            body: {
                checkPeriod: data.checkPeriod,
                checkPeriodFirstMonth:
                    data.checkPeriod === AccountingDomainEntitiesBudgetCheckPeriod.AnnuallyWithCustomFirstMonth ||
                    data.checkPeriod === AccountingDomainEntitiesBudgetCheckPeriod.YearToDateWithCustomFirstMonth
                        ? data.checkPeriodFirstMonth
                        : undefined,
                zeroAmountHandlingType: data.zeroAmountHandlingType,
            },
        });
    });

    return (
        <Form form={form} onSubmit={handleSubmit}>
            <Popup.Header
                title={messages.title({
                    budgetName: budget.name,
                })}
                actions={
                    <Button disabled={isLoadingUpdateQBooksBudget} type='submit' color='blue80' size='medium'>
                        {messages.saveButton}
                    </Button>
                }
                progress={isLoadingUpdateQBooksBudget}
            />

            <Popup.Body>
                <Text font='body' spacing='0 0 24'>
                    {messages.description({
                        name: <b>{budget.name}</b>,
                        br: <br />,
                    })}
                </Text>

                <CheckPeriodFormPart origin={domain.BudgetOrigin.QBooks} learnMoreLink={checkPeriodLearnMoreLink} />

                <ZeroAmountFormPart title={messages.zeroAmountSettingTitle} learnMoreLink={zeroAmountLearnMoreLink} />
            </Popup.Body>
        </Form>
    );
});

BudgetSettingsPopupContent.displayName = 'BudgetSettingsPopupContent';
